$(function () {
    //Turn off ajax cache in IE7-8
    $.ajaxSetup({
        cache: false
    });
});


var EmptyGUID = "00000000-0000-0000-0000-000000000000"


$(function() {

    $("#postUploadform").click(function(e) {
        document.frmCreateYourOwnLamp.submit();
    });
});

function getGoggleTrackingDownload(str) {
    setTimeout('pageTracker._trackPageview("' + str + '")', 1000);
}


$(function(){
    function topMenuDropDown(){
        this.showDropDown = function(jElemTriger){
            if(jElemTriger.is(":hidden"))
                jElemTriger.show();
         }
        this.closeDropDown = function(jElemTriger){
                jElemTriger.hide();
            }
    }
    var dropDownObj = new topMenuDropDown();
    $(".main_menu li").mouseover(function(e) {
            var elm = $(this).contents().filter("div");
            dropDownObj.showDropDown(elm);
            }).mouseout(function(){
                var elm1 = $(this).contents().filter("div");
                dropDownObj.closeDropDown(elm1);
                });
});
$(function () {
    $(document).ajaxError(function (ev, request) {
        if (request.status === 403 && request.statusText === "SESSIONTIMEOUT") {
            window.location = "/Home/SessionTimeout";
        }
    });
    $("div.scrollable").scrollable();
});


function getGoggleEventDownload(category, action_val, opt_label) {
    setTimeout('pageTracker._trackEvent("' + category + '","' + action_val + '","' + opt_label + '")', 1000);
}


// jquery function for checking if mouse is over element
(function ($) {
    jQuery.MouseLastPosition = { x: 0, y: 0 }; // Mouse Last Position
    $(document).mousemove(function (e) {
        jQuery.MouseLastPosition = { x: e.pageX, y: e.pageY }
    });
    function notNans(value) {
        if (isNaN(value)) {
            return 0;
        } else {
            return value
        }
    }

    $.fn.ismouseover = function (overThis) {
        var result;
        this.eq(0).each(function () {
            var offSet = $(this).offset();
            var w = Number($(this).width())
            + notNans(Number($(this).css("padding-left").replace("px", "")))
            + notNans(Number($(this).css("padding-right").replace("px", "")))
            + notNans(Number($(this).css("border-right-width").replace("px", "")))
            + notNans(Number($(this).css("border-left-width").replace("px", "")));
            var h = Number($(this).height())
            + notNans(Number($(this).css("padding-top").replace("px", "")))
            + notNans(Number($(this).css("padding-bottom").replace("px", "")))
            + notNans(Number($(this).css("border-top-width").replace("px", "")))
            + notNans(Number($(this).css("border-bottom-width").replace("px", "")));
            if (offSet.left < jQuery.MouseLastPosition.x && offSet.left + w > jQuery.MouseLastPosition.x
             && offSet.top < jQuery.MouseLastPosition.y && offSet.top + h > jQuery.MouseLastPosition.y) {
                result = true;
            } else {
                result = false;
            }
        });
        return result;
    };
})(jQuery);



var imat = imat||{};
imat.namespace = function(name) {

    function getGlobal() {
        return (function() { return this; }).call(null);
    }

    function extendNS(parent, subNS) {
        if (typeof parent[subNS] === "undefined") {
            parent[subNS] = {};
        }
        return parent[subNS];
    }
    var parent = getGlobal();
    var parts = name.split('.');

    for (var i = 0; i < parts.length; i++) {
        parent = extendNS(parent, parts[i]);
    }

    return parent;
};

imat.Localizator = function () {

    var resources = {};

    function registerResources(resource) {
        extend(resources, resource);
    }

    function extend(target, source) {
        for(var propKey in source) {
            target[propKey] = source[propKey];
        }
    }

    function getValue(key) {
        if (resources[key] !== undefined) {
            return resources[key];
        }
        return key;
    }
    
    function getFormatedValue(key, params) {
        if (resources[key] !== undefined) {
            var str = resources[key];
            for (var i = 0; i < params.length; i++) {
                str = str.replace("{" + i + "}", params[i]);
            }
            return str;
            
        }
        return key;
    }

    return {
        getValue: getValue,
        getFormatedValue: getFormatedValue,
        registerResources: registerResources
    };
}();